import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { useCentro } from "@/lib/centro";
import { PageTitle } from "@/components/Badges";
import { masMeses } from "@/components/AgendarRevision";

const en30 = masMeses(new Date().toISOString().slice(0, 10), 1);
const GRUPOS = [
  { id: "eficacia", label: "Toca revisión de eficacia", cls: "text-rose-700", fn: (r) => r.en_terapia && r.toca_eficacia, det: (r) => `${r.sesiones} sesiones · tocaba en la ${r.prox_eficacia_sesion}` },
  { id: "procesamiento", label: "Toca revisión de procesamiento", cls: "text-rose-700", fn: (r) => r.en_terapia && r.toca_procesamiento, det: (r) => `desde el ${fmtDate(r.fecha_procesamiento)} · 1ª sesión ${fmtDate(r.primera_sesion)}` },
  { id: "informes", label: "Informes de revisión pendientes", cls: "text-amber-700", fn: (r) => r.informes_pendientes.length > 0,
    det: (r) => r.informes_pendientes.map((i) => `${i.tipo === "eficacia" ? "Eficacia" : "Procesamiento"} ${fmtDate(i.fecha)}: ${i.informe_hecho ? "hecho, falta entregar" : "por hacer"}`).join(" · ") },
  { id: "proximas", label: "Próximas (3 sesiones o 1 mes)", cls: "text-slate-600", fn: (r) => r.en_terapia && ((!r.toca_eficacia && r.faltan_eficacia <= 3) || (!r.procesamiento_hecho && !r.toca_procesamiento && r.fecha_procesamiento && r.fecha_procesamiento <= en30)),
    det: (r) => [!r.toca_eficacia && r.faltan_eficacia <= 3 && `eficacia en ${r.faltan_eficacia} sesiones`, !r.procesamiento_hecho && !r.toca_procesamiento && r.fecha_procesamiento <= en30 && `procesamiento el ${fmtDate(r.fecha_procesamiento)}`].filter(Boolean).join(" · ") },
];

const Grupo = ({ g, list }) => (
  <div className="mb-6 fade-up" data-testid={`ct-grupo-${g.id}`}>
    <h3 className={`text-xs font-semibold uppercase tracking-wider mb-2 ${g.cls}`}>{g.label} · {list.length}</h3>
    <div className="bg-white border border-slate-200 rounded-lg divide-y divide-slate-100">
      {list.length === 0 && <p className="px-3 py-2 text-sm text-slate-400">Nadie.</p>}
      {list.map((r) => (
        <Link key={r.patient_id} to={`/pacientes/${r.patient_id}`} data-testid={`ct-${g.id}-${r.patient_id}`} className="flex flex-wrap items-center gap-3 px-3 py-2 text-sm hover:bg-slate-50">
          <span className="font-medium text-slate-900">{r.paciente}</span>
          <span className="text-xs text-slate-500">{r.centro}{r.telefono ? ` · ${r.telefono}` : ""}</span>
          <span className="ml-auto text-xs text-slate-600">{g.det(r)}</span>
        </Link>
      ))}
    </div>
  </div>
);

export default function ControlTerapia() {
  const { centro } = useCentro();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/control-terapia", { params: { centro } }).then((r) => setRows(r.data));
  }, [centro]);
  return (
    <div data-testid="control-terapia-page">
      <PageTitle title="Revisiones de terapia" subtitle="Eficacia cada 12 sesiones de terapia visual y procesamiento a los 9 meses de la 1ª sesión" />
      {rows === null ? <p className="text-sm text-slate-400">Cargando…</p> : GRUPOS.map((g) => <Grupo key={g.id} g={g} list={rows.filter(g.fn)} />)}
    </div>
  );
}
